<p>promotion-list works!</p>
